import { render } from "./WidgetBox.vue?vue&type=template&id=019fccc8&scoped=true"
import script from "./WidgetBox.vue?vue&type=script&lang=js"
export * from "./WidgetBox.vue?vue&type=script&lang=js"

import "./WidgetBox.vue?vue&type=style&index=0&id=019fccc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019fccc8"]])

export default __exports__